import { z } from 'zod'
import { nullSafeOptionalFirestoreTimestamp } from '../shared/schema'

export const schema = z.object({
  organizationId: z.string(),
  userId: z.string(),
  autoApproveInvoice: z.boolean().default(false),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const empty = Object.freeze(
  schema.parse({
    organizationId: '',
    userId: '',
  })
)

export type FirestoreOrganizationInstructor = z.infer<typeof schema>
